import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../ApiClient";
import { APP_AUTH_URL } from "../../Process";
import { SITELINKS } from "../../../app-routes/links";
import { useGlobalState } from "../../../context/GlobalStateContext";

const useLoginTepngUser = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const { dispatch } = useGlobalState();

  const login = useCallback(() => {
    setLoading(true);
    setError(null);

    // updated login endpoint
    apiClient
      .post("Authentication/UserLogin", {})
      .then((res) => {
        const data = res.data.data;
        const userRoles = data?.roles;
        const rolesSet = new Set(userRoles);

        dispatch({ type: "SET_TEPNGUSER", payload: data });
        // setAuthorizationToken(data?.accessToken);

        const loginRedirectedFromUrl = localStorage.getItem(
          "loginRedirectedFromUrl"
        );
        localStorage.removeItem("loginRedirectedFromUrl");

        let userView = SITELINKS.SIGNIN;
        if (rolesSet.has("MarineApproval")) {
          userView = SITELINKS.DASHBOARD_ADMIN;
        }
        if (rolesSet.has("MarineSuperintendent")) {
          userView = SITELINKS.DASHBOARD_MARINESUPERINTENDENT;
        }
        if (rolesSet.has("VesselOperator")) {
          userView = SITELINKS.DASHBOARD_VO;
        }
        if (rolesSet.has("Administrator")) {
          userView = SITELINKS.DASHBOARD_ADMIN;
        }

        navigate(loginRedirectedFromUrl ?? userView);
      })

      .catch((err) => {
        const query = new URLSearchParams(window.location.search);

        if (
          query.get("azureauthredirect") !== "1" &&
          err.match("UNAUTHORIZED ACCESS")
        ) {
          const login_url = new URL(window.location.origin + SITELINKS.SIGNIN);
          login_url.searchParams.append("azureauthredirect", "1");

          window.location.replace(
            APP_AUTH_URL + window.encodeURIComponent(login_url.href)
          );
        } else {
          setError(err);
        }
      })

      .finally(() => {
        setLoading(false);
      });
  }, [navigate, dispatch]);

  return { login, loading, error };
};

export default useLoginTepngUser;
